import React from 'react';
import SanrioSparklingSpring26 from '../img/Sanrio_SparklingSpring26.png';
import SanrioVfes26 from '../img/SanrioVfes26.jpg';
//import Vrc1 from '../img/vrcWld1.png';
import Kamitsubaki from '../img/KamitsubakiVR.webp';
import unity from '../img/Unity.svg';
import '../Style/WorksHighlights.css';
import VHF_Eva from '../img/VHF_Eva.jpg';
import SanrioVfes25 from '../img/SanrioVfes2025.webp';
import virtualHiroshima from '../img/VirtualHiroshima.webp';
import hiroshimaTalkShow from '../img/Hiroshima_TalkShow.webp';
import hiroshimaTalkShowInoueMasahiro from '../img/Hiroshima_TalkShow_InoueMasahiro.jpg';

const projectItems = [
  {
    title: 'バーチャル広島駅 2.u',
    image: virtualHiroshima,
    alt: 'VirtualHiroshima',
    category: 'VRChatWorld',
    details: ['VRChatワールド制作', 'Worldギミック、演出制作を担当'],
  },
  {
    title: 'バーチャル広島駅 クリエーターTalkShow',
    image: hiroshimaTalkShow,
    alt: 'Hiroshima_Talkshow',
    category: 'VRChatイベント',
    details: ['イベント進行に関わるWorldギミックを担当'],
  },
  {
    title: 'バーチャル広島駅 井上正大さんTalkShow',
    image: hiroshimaTalkShowInoueMasahiro,
    alt: 'Hiroshima_Talkshow_InoueMasahiro',
    category: 'VRChatイベント',
    details: ['イベントスタッフ・運営', 'イベント用ギミック、演出調整を担当'],
  },
  {
    title: '神椿市建設中。VIRTUAL REALITY',
    image: Kamitsubaki,
    alt: 'Unity を用いた XR 開発',
    category: 'VRシナリオゲーム',
    summary:
      '「神椿市建設中。VIRTUAL REALITY」にて、イベント・インタラクト開発、QA、デバッグ、揺れもの設定を担当。',
    details: [
      '2024/11 - 2026/01、Meta Quest 3向けVRゲーム開発に参画',
      'インタラクション, 演出制作, QA, デバッグ, Magica設定など担当',
    ],
  },
  {
    title: 'Sanrio Sparkling Spring 2026',
    image: SanrioSparklingSpring26,
    alt: 'Sanrio Sparkling Spring 2026',
    category: 'VRChatイベント',
    details: [
      '2026/04 - 2026/05',
      'Worldギミック,UIの最適化',
      'UrlLauncherの実装, ImageLoading, StringLoading実装',
    ],
  },
  {
    title: 'Sanrio Virtual Festival 2026',
    image: SanrioVfes26,
    alt: 'Sanrio Virtual Festival のキービジュアル',
    category: 'VRChatイベント',
    summary:
      'VRChat上の大規模イベントで、演出調整、UI実装、新規ギミック開発、ローカライズを担当。',
    details: [
      '2025/09 - 現在、社外連携を含む案件に参画',
      '仕様整理と説明方法を改善し、実装進行を円滑化',
    ],
  },
  {
    title: 'Sanrio Virtual Festival 2025',
    image: SanrioVfes25,
    alt: 'Sanrio Virtual Festival のキービジュアル',
    category: 'VRChatイベント',
    summary: 'アーティストパフォーマンスワールドの設定、ギミック実装',
    details: [
      '2025/09 - 2025/10',
      '仕様整理と説明方法を改善し、実装進行を円滑化, Worldギミックの実装, UI実装, ローカライズ',
    ],
  },
  {
    title: '自社モバイルアプリ開発',
    image: unity,
    alt: 'モバイルアプリUI開発のイメージ',
    category: 'モバイル開発',
    summary:
      '自社スマホアプリで、新規画面実装、UIレイアウト、ローカライズ、リリース作業を担当。',
    details: [
      '2025/10 - 2025/12、2名体制で開発',
      '多言語UI崩れを調整し、設計視点で実装',
    ],
  },
  {
    title: 'Virtual Hoby Festival',
    image: VHF_Eva,
    alt: 'Virtual Hoby Festival Evangelionのイメージ',
    category: 'VRChatWorldギミック',
    summary: 'VRChat上のイベントで、エヴァンゲリオンのポーズギミックを制作',
    details: ['2026/02 - 2026/03', '同期システムの最適化'],
  },
];

const orderedProjectItems = [
  ...projectItems.slice(3),
  ...projectItems.slice(0, 3),
];

function WorksHighlights() {
  return (
    <section className="works-highlights">
      <h2 className="textCenter">-Works-</h2>
      <div className="works-project-grid">
        {orderedProjectItems.map((project) => (
          <article key={project.title} className="works-project-card">
            <div className="works-project-image-wrap">
              <img
                className="works-project-image"
                src={project.image}
                alt={project.alt}
              />
              <span className="works-project-category">{project.category}</span>
            </div>

            <div className="works-project-body">
              <h3>{project.title}</h3>
              <p>{project.summary}</p>
              <ul>
                {project.details.map((detail) => (
                  <li key={detail}>{detail}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default WorksHighlights;
